import AddModeratorIcon from "@mui/icons-material/AddModerator";
import BatteryCharging20Icon from "@mui/icons-material/BatteryCharging20";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import EggIcon from "@mui/icons-material/Egg";
import ElectricRickshawIcon from "@mui/icons-material/ElectricRickshaw";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import LivingIcon from "@mui/icons-material/Living";
import MinorCrashIcon from "@mui/icons-material/MinorCrash";
import RecyclingIcon from "@mui/icons-material/Recycling";
import SavingsIcon from "@mui/icons-material/Savings";
import SwipeRightIcon from "@mui/icons-material/SwipeRight";
import ThreeSixtyIcon from "@mui/icons-material/ThreeSixty";
import TimeToLeaveIcon from "@mui/icons-material/TimeToLeave";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
export const OEMAdv = {
  osm: [
    {
      icon: <EggIcon />,
      heading: "Zero-emissions",
      description:
        "Every OSM auto electric model ensures a 100% green footprint. This is helping businesses meet sustainability goals while navigating city roads without any tailpipe pollution.",
    },
    {
      icon: <BatteryCharging20Icon />,
      heading: "Long battery life",
      description:
        "The OSM ev auto price includes advanced Lithium-ion technology designed to last over 1,000 cycles, ensuring years of reliable service. It also comes with 3 years of battery warranty.",
    },
    {
      icon: <WaterDropIcon />,
      heading: "Regenerative braking",
      description:
        "OSM three wheeler comes with regenerative braking technology. Its benefit is that it captures energy while braking and charges the battery pack, leading to a longer daily range.",
    },
    {
      icon: <SwipeRightIcon />,
      heading: "Easy to operate",
      description:
        "The OSM 3 wheeler features a simple twist-and-go automatic transmission. Overall, this helps in reducing driver fatigue in heavy stop-and-go urban traffic conditions.",
    },
    {
      icon: <LivingIcon />,
      heading: "Comfortable ride",
      description:
        "Experience a superior OSM ev auto journey thanks to an advanced suspension system and an ergonomically designed cabin to tackle long shifts.",
    },
    {
      icon: <RecyclingIcon />,
      heading: "Durable construction",
      description:
        "The OSM Rage Plus is built on a heavy-duty reinforced steel chassis, making it the most rugged OSM vehicle available.",
    },
  ],

  piaggio: [
    {
      icon: <ElectricRickshawIcon />,
      heading: "India's Most Powerful Commercial EVs",
      description:
        "Piaggio offers class-leading power delivery across all driving conditions, ensuring your Ape Electric auto can carry heavy loads, from flyovers to steep gradients effortlessly, ensuring timely logistics every time.",
    },
    {
      icon: <EmojiEventsIcon />,
      heading: "Leader in the Segment",
      description:
        "As a legacy brand, the Piaggio tempo remains the market leader, offering the most trusted network for parts and service nationwide, eliminating hassles related to maintenance and ensuring cost effective repairs.",
    },
    {
      icon: <AddModeratorIcon />,
      heading: "Strong Vehicle Body",
      description:
        "Built with a rugged metal body, the Piaggio Electric Rickshaw is designed for durability and high safety, no matter the driving conditions, whether it is in heavy Indian traffic or rural roads.",
    },
    {
      icon: <MinorCrashIcon />,
      heading: "Superior Range",
      description:
        "The Piaggio Electric Auto mileage is optimized for high productivity, allowing drivers to complete more trips without frequent stops for charging, increasing cost effective delivery schedules.",
    },
    {
      icon: <ThreeSixtyIcon />,
      heading: "Instant Torque",
      description:
        "With an electric drivetrain, the Ape City Electric Auto provides instant torque, making it quick and agile in congested city streets, and well equipped to pull loads.",
    },
    {
      icon: <SavingsIcon />,
      heading: "Cost Savings",
      description:
        "Switching from diesel to electric drastically reduces your running costs, as the Piaggio Battery Auto price is offset by massive fuel savings, both in the short and long term.",
    },
    {
      icon: <TimeToLeaveIcon />,
      heading: "Quiet and Smooth Ride",
      description:
        "The gearless and clutchless operation provides a noise-free experience, reducing driver fatigue and enhancing the passenger experience in your Piaggio EV Auto.",
    },
  ],
  mahindra: [
    {
      icon: <CurrencyRupeeIcon />,
      heading: "Affordability",
      description:
        "With a competitive Mahindra auto price, these vehicles offer a faster Return on Investment (ROI) compared to traditional diesel or CNG variants.",
    },
    {
      icon: <EggIcon />,
      heading: "Zero-emissions",
      description:
        "The Mahindra electric auto helps reduce urban pollution, making it the perfect choice for city silent zones and eco-conscious businesses.",
    },
    {
      icon: <BatteryCharging20Icon />,
      heading: "Long battery life",
      description:
        "Mahindra uses advanced Lithium-ion technology, resulting in robust high-quality battery packs that often stand strong even with rigorous usage, ensuring the Mahindra battery auto price is justified by a lifespan that often exceeds 5 years.",
    },
    {
      icon: <WaterDropIcon />,
      heading: "Regenerative braking",
      description:
        "Regenerative braking is a process in which electric vehicles are able to recover some of the lost battery juice through braking activity, extending the Mahindra tempo range during heavy stop-and-go city traffic.",
    },
    {
      icon: <SwipeRightIcon />,
      heading: "Easy to operate",
      description:
        "The Mahindra auto rickshaw comes equipped with an automatic transmission void of any clutch or gears and significantly reduces driver fatigue during long hauls.",
    },
    {
      icon: <LivingIcon />,
      heading: "Comfortable ride",
      description:
        "A best-in-class wheelbase, vibration free cabin, and thoughtfully engineered suspension setup result in superior comfort in the Mahindra electric tempo.",
    },
    {
      icon: <RecyclingIcon />,
      heading: "Durability",
      description:
        "Built with a rugged IP67-rated motor and a sturdy frame, the Mahindra loader price ensures your vehicle withstands heavy loads and waterlogged roads.",
    },
  ],
  euler: [
    {
      icon: <ElectricRickshawIcon />,
      question: "Powerful Performance",
      answer:
        "Performance is the foremost requirement of any logistics business. And thus, every Euler EV delivers industry-leading torque, ensuring your Euler tempo can carry heavy loads across flyovers and steep urban terrains easily.",
    },
    {
      icon: <EmojiEventsIcon />,
      question: "High Efficiency",
      answer:
        "The Euler electric auto offers up to a respectable 170km real-world range. This kind of long-range helps you maximise your daily trips and significantly boost your overall monthly business earning potential.",
    },
    {
      icon: <AddModeratorIcon />,
      question: "User-friendly Design",
      answer:
        "Usability and comfort cannot be ignored as Euler three wheelers get an ergonomic cabin and advanced telematics offering driver comfort, real-time fleet tracking and health updates.",
    },
    {
      icon: <AddModeratorIcon />,
      question: "Superior Safety System",
      answer:
        "Euler electric 3 wheelers come fitted with industry-leading liquid-cooled battery packs and disc brakes. These features are important in keeping the vehicle safe and allow longer operations without any risk.",
    },
    {
      icon: <SavingsIcon />,
      question: "Pocket-Friendly Operation",
      answer:
        "Euler hiload ev price becomes an investment as it comes with low maintenance and high energy efficiency. It ultimately pays for itself through massive savings on fuel and maintenance.",
    },
  ],
  eulerHindiAdvantages: [
    {
      icon: <ElectricRickshawIcon />,
      question: "पावरफुल परफॉरमेंस:",
      answer:
        "Euler 3-व्हीलर्स को 688 किलोग्राम तक की हाई पेलोड कैपेसिटी के लिए डिज़ाइन किया गया है, जिसमें एक बड़ी बैटरी है जो 15 मिनट में 50 किमी तक तेजी से चार्ज हो जाती है।",
    },
    {
      icon: <EmojiEventsIcon />,
      question: "उच्च क्षमता:",
      answer:
        "Euler इलेक्ट्रिक ऑटो मॉडल किसी भी जगह कुछ भी लोड करने के लिए बनाए गए हैं, जिनकी रेंज 125 किलोमीटर और 88.5Nm टॉर्क है।",
    },
    {
      icon: <AddModeratorIcon />,
      question: "यूजर- फ्रेंडली डिज़ाइन:",
      answer:
        "ये Euler मोटर्स द्वारा डिजाइन की गई लोड EV गाड़ी की टायर और विंडशील्ड में 30% अधिक चौड़ाई है और एक बड़ा डिलीवरी बॉक्स है।",
    },
    {
      icon: <AddModeratorIcon />,
      question: "बेहतरीन सुरक्षा:",
      answer:
        "ये Euler इलेक्ट्रिक ऑटो लिक्विड-कूल बैटरी पैक, रिमोट गाड़ी नियंत्रण और ट्रैकिंग सॉफ़्टवेयर, और बेजोड़ रोकने की शक्ति के लिए 20mm के फ्रंट डिस्क ब्रेक्स के साथ बनाए गए हैं।",
    },

    {
      icon: <SavingsIcon />,
      question: "चलाने में किफायती :",
      answer:
        "Euler 3-व्हीलर्स कम कीमतों और कम मेंटेनेंस लागतों के साथ बचत को बढ़ाता है।",
    },
  ],
  etrio: [
    {
      icon: <ElectricRickshawIcon />,
      heading: "Powerful Performance",
      description:
        "The Etrio electric 3 wheeler provides superior torque and gradability so that it becomes easier to navigate steep urban flyovers and heavy traffic effortlessly.",
    },
    {
      icon: <EmojiEventsIcon />,
      heading: "Intelligent EV Technology",
      description:
        "Fleet owners can track vehicle location, battery health, charging, up and down-time with every Etrio electric commercial vehicle as they are integrated with cloud-based telematics.",
    },
    {
      icon: <AddModeratorIcon />,
      heading: "Advanced Battery",
      description:
        "The advanced Etrio electric auto battery price reflects its value, offering exceptional Etrio electric auto mileage and long-term cycle life.",
    },
    {
      icon: <AddModeratorIcon />,
      heading: "Sturdy Safety System",
      description:
        "Etrio has ensured that all its vehicles are packed with modern safety features in its battery pack, reinforced chassis and hydraulic disc brakes. Visit an Etrio electric auto showroom near me to check out all the safety features.",
    },
    {
      icon: <SavingsIcon />,
      heading: "Pocket-Friendly Options",
      description:
        "Competitive Etrio electric auto price helps them stay in the business-friendly territory. We offer lower TCO compared to diesel, especially with exclusive Turno Etrio offers.",
    },
  ],
  altigreen: [
    {
      icon: <ElectricRickshawIcon />,
      heading: "Zero Range Anxiety: ",
      description:
        "With a certified range of up to 151 kilometres, Altigreen vehicles provide the confidence to cover substantial distances without worrying about recharging.",
    },
    {
      icon: <EmojiEventsIcon />,
      heading: "Ample Cargo Space:",
      description:
        "Altigreen vehicles come with a spacious 177 cu. ft. container, allowing you to transport more goods efficiently.",
    },
    {
      icon: <AddModeratorIcon />,
      heading: "Unparalleled Ground Clearance::",
      description:
        "Offering a best-in-class ground clearance of 220mm, Altigreen vehicles effortlessly tackle diverse terrains, ensuring smoother journeys.",
    },
    {
      icon: <AddModeratorIcon />,
      heading: "High Torque:",
      description:
        "Altigreen vehicles boast the highest torque in their segment, ensuring remarkable performance even under demanding conditions.",
    },

    {
      icon: <SavingsIcon />,
      heading: "Fatigue-Free Smooth Driving",
      description:
        "Altigreen’s electric vehicles offer a serene driving experience, minimising driver fatigue during long journeys.",
    },
    {
      icon: <SavingsIcon />,
      heading: "Robust Construction for Indian Roads:",
      description:
        "Built to withstand the challenges of Indian roads, Altigreen vehicles are constructed for durability and reliability, ensuring a safe and efficient delivery journey.",
    },
  ],

  greaves: [
    {
      icon: <ElectricRickshawIcon />,
      heading: "Outstanding Performance:",
      description:
        "Featuring a powerful 9.5 kW PMS Motor and a reliable 10.8 kWh LFP Battery that provides a range of approximately 105 km per charge and acceleration from 0-30 km/hr in just 6.4 seconds.",
    },
    {
      icon: <EmojiEventsIcon />,
      heading: "Advanced Technology:",
      description:
        "Greaves electric vehicles include an IoT-enabled futuristic digital cluster for real-time GPS tracking, simplifying fleet management through a mobile app, and seamless Bluetooth Connectivity.",
    },
    {
      icon: <AddModeratorIcon />,
      heading: "Significant Savings:",
      description:
        "Greaves electric trucks allow you to cover up to 100 km on just ₹86 of electricity. Over 5 years, you can save up to ₹4 lakhs compared to diesel 3-wheelers, with minimal maintenance costs.",
    },
    {
      icon: <SavingsIcon />,
      heading: "Convenience Redefined:",
      description:
        "Easily transport goods up to 530 kg with a gradeability of 12 degrees. Easy Home Charging in 5-6 hours with zero downtime during daily operations.",
    },
    {
      icon: <ElectricRickshawIcon />,
      heading: "Backed by an 164-year Old Legacy:",
      description:
        "Greaves Electric Vehicles come from the trusted Greaves brand and they have a Pan-India availability of service and spare parts network support. With their 24x7 Road-Side Assistance and up to 5 years extended warranty, always keep moving.",
    },
  ],
};

export const OEMAdvHindi = {
  mahindra: [
    {
      icon: <CurrencyRupeeIcon />,
      heading: "किफायती",
      description:
        "महिंद्रा की इलेक्ट्रिक ऑटो रख रखाव और चलाने में बहुत किफायती हैं। पेट्रोल और डीजल गाड़ी के  मुकाबले इसकी चलने का खर्च आधी से भी कम होती हैं।",
    },
    {
      icon: <EggIcon />,
      heading: " शून्य प्रदुषण",
      description:
        "महिंद्रा के इलेक्ट्रिक गाड़ी किसी तरह की प्रदूषण नहीं फैलाती हैं, जिससे यह पर्यावरण के लिए बेहद उपयुक्त बन जाती हैं। अगर आप अपनी कार्बन फुटप्रिंट  को कम करना चाहते हैं तो महिंद्रा आपके लिए सबसे बेहतर गाड़ी हैं।",
    },
    {
      icon: <BatteryCharging20Icon />,
      heading: "लम्बी बैटरी लाइफ",
      description:
        "महिंद्रा लोड ऑटो की बैटरी लाइफ लम्बी होती हैं जिससे आप पॉवर  की चिंता  किए बिना लम्बी दूरियां  तक यात्रा कर सकते हैं।",
    },
    {
      icon: <WaterDropIcon />,
      heading: "रीजेनरेटिव ब्रेकिंग",
      description:
        "महिंद्रा मे रीजेनरेटिव ब्रेकिंग सिस्टम हैं, जो ऊर्जा को बचता हैं और बैटरी की लाइफ को बढ़ाता हैं। रीजेनरेटिव ब्रेकिंग के कारण  बैटरी लम्बे समय तक चलती हैं।",
    },
    {
      icon: <SwipeRightIcon />,
      heading: "आसान संचालन",
      description:
        "महिंद्रा इलेक्ट्रिक ऑटो की उपयोगिता और सरलता के कारण इसे चलाना बहुत ही आसान हैं।   इसे नौसिखिए भी आसानी से चला सकते हैं।",
    },
    {
      icon: <LivingIcon />,
      heading: "आरामदायी यात्रा",
      description:
        "महिंद्रा मिनी ट्रक को डिज़ाइन करते हुए आरामदायक ड्राइविंग को ध्यान में रखा गया हैं।  यह सुनिश्चित करता हैं कि लंबी यात्राओं पर भी एक आरामदायक सवारी मिल सके।",
    },
    {
      icon: <RecyclingIcon />,
      heading: "टिकाऊ",
      description:
        "महिंद्रा बैटरी ऑटो बहुत ही टिकाऊ हैं। इसे रोज़ाना के उपयोग में आने वाली कठिनाइयों को सहने के लिए मजबूती से बनाया गया हैं।",
    },
  ],
};
export const OEMAdvKannada = {
  mahindra: [
    {
      icon: <CurrencyRupeeIcon />,
      heading: "ಕೈಗೆಟಕುವ ದರ",
      description:
        "3 ವೀಲರ್‌ಗಳನ್ನು ಒಳಗೊಂಡಂತೆ ಮಹೀಂದ್ರಾ ಎಲೆಕ್ಟ್ರಿಕ್ ಆಟೋ, ಹೊಂದಲು ಮತ್ತು ನಿರ್ವಹಿಸಲು ವೆಚ್ಚ-ಪರಿಣಾಮಕಾರಿಯಾಗಿದೆ. ಮುಂಗಡ ವೆಚ್ಚವು ಪೆಟ್ರೋಲ್ ಅಥವಾ ಡೀಸೆಲ್ ವಾಹನಗಳಿಗಿಂತ ಕಡಿಮೆಯಿರುತ್ತದೆ ಮತ್ತು ಚಾಲನೆಯ ವೆಚ್ಚವು ಗಣನೀಯವಾಗಿ ಕಡಿಮೆಯಾಗುತ್ತದೆ.",
    },
    {
      icon: <EggIcon />,
      heading: "ಶೂನ್ಯ-ಹೊರಸೂಸುವಿಕೆ",
      description:
        "ಮಹೀಂದ್ರಾ ಎಲೆಕ್ಟ್ರಿಕ್ ವಾಹನಗಳು ಶೂನ್ಯ ಹೊರಸೂಸುವಿಕೆಯನ್ನು ಉತ್ಪಾದಿಸುತ್ತವೆ, ಅವುಗಳನ್ನು ಪರಿಸರ ಸ್ನೇಹಿ ಆಯ್ಕೆಯನ್ನಾಗಿ ಮಾಡುತ್ತದೆ, ತಮ್ಮ ಇಂಗಾಲದ ಹೊರಸೂಸುವಿಕೆಯನ್ನು ಕಡಿಮೆ ಮಾಡಲು ಬಯಸುವವರಿಗೆ ಸೂಕ್ತವಾಗಿದೆ.",
    },
    {
      icon: <BatteryCharging20Icon />,
      heading: "ದೀರ್ಘ ಬ್ಯಾಟರಿ ಬಾಳಿಕೆ",
      description:
        "ಮಹೀಂದ್ರಾ ಲೋಡ್ ಆಟೋ ದೀರ್ಘ ಬ್ಯಾಟರಿ ಅವಧಿಯನ್ನು ಹೊಂದಿದೆ, ಚಾರ್ಜ್ ಖಾಲಿಯಾಗುವುದರ ಬಗ್ಗೆ ಚಿಂತಿಸದೆ ದೂರದ ಪ್ರಯಾಣದ ಸಾಮರ್ಥ್ಯವನ್ನು ಒದಗಿಸುತ್ತದೆ.",
    },
    {
      icon: <WaterDropIcon />,
      heading: "ಪುನರುತ್ಪಾದಕ ಬ್ರೇಕಿಂಗ್",
      description:
        "ಮಹೀಂದ್ರಾ ಪುನರುತ್ಪಾದಕ ಬ್ರೇಕಿಂಗ್ ತಂತ್ರಜ್ಞಾನವನ್ನು ಹೊಂದಿದೆ, ಶಕ್ತಿಯನ್ನು ಉಳಿಸುತ್ತದೆ ಮತ್ತು ಬ್ಯಾಟರಿ ಅವಧಿಯನ್ನು ವಿಸ್ತರಿಸುತ್ತದೆ, ಒಟ್ಟಾರೆ ದಕ್ಷತೆಯನ್ನು ಹೆಚ್ಚಿಸುತ್ತದೆ.",
    },
    {
      icon: <SwipeRightIcon />,
      heading: "ಕಾರ್ಯಾಚರಣೆಯ ಸುಲಭ",
      description:
        "ಮಹೀಂದ್ರಾ ಎಲೆಕ್ಟ್ರಿಕ್ ಆಟೋಗಳು ಬಳಕೆದಾರ ಸ್ನೇಹಿ ಮತ್ತು ಕಾರ್ಯನಿರ್ವಹಿಸಲು ಸುಲಭವಾಗಿದೆ, ಇದು ಮೊದಲ ಬಾರಿಗೆ ಖರೀದಿಸುವವರಿಗೆ ಮತ್ತು ಚಾಲಕರಿಗೆ ಸೂಕ್ತವಾಗಿದೆ.",
    },
    {
      icon: <LivingIcon />,
      heading: "ಆರಾಮದಾಯಕ ಸವಾರಿ",
      description:
        "ಮಹೀಂದ್ರಾ ಮಿನಿ ಟ್ರಕ್‌ಗಳು ದೀರ್ಘ ಪ್ರಯಾಣದಲ್ಲಿಯೂ ಸಹ ಪ್ರಯಾಣಿಕರಿಗೆ ಮತ್ತು ಚಾಲಕರ ಸೌಕರ್ಯವನ್ನು ಖಾತ್ರಿಪಡಿಸುವ ಆರಾಮದಾಯಕ ಸವಾರಿಯನ್ನು ನೀಡುತ್ತವೆ.",
    },
    {
      icon: <RecyclingIcon />,
      heading: "ಬಾಳಿಕೆ",
      description:
        "ಮಹೀಂದ್ರಾ ಬ್ಯಾಟರಿ ಆಟೋಗಳನ್ನು ಬಾಳಿಕೆಯೊಂದಿಗೆ ನಿರ್ಮಿಸಲಾಗಿದೆ, ಇದು ದೈನಂದಿನ ವ್ಯವಹಾರದ ಬಳಕೆಯ ಕಠಿಣತೆಯನ್ನು ತಡೆದುಕೊಳ್ಳುವ ದೀರ್ಘಕಾಲೀನ ಹೂಡಿಕೆಯನ್ನು ಖಾತ್ರಿಗೊಳಿಸುತ್ತದೆ.",
    },
  ],
};
